import { render, staticRenderFns } from "./FooterSocials.vue?vue&type=template&id=a73632fe&scoped=true&"
var script = {}
import style0 from "./FooterSocials.vue?vue&type=style&index=0&id=a73632fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73632fe",
  null
  
)

export default component.exports